import { useEffect, useState } from 'react'

const COOLDOWN_STORAGE_KEY = 'auth-cooldown'

//Кулдаун после вызова ожидания звонка пользователя
export const COOLDOWN_CALL_SEC = 120
//Кулдаун после запроса кода
export const COOLDOWN_CODE_SEC = 59

export const useAuthCooldown = () => {
	const [resendCooldown, setResendCooldown] = useState(0)

	const startCooldown = (seconds: number = COOLDOWN_CODE_SEC) => {
		setResendCooldown(seconds)
		localStorage.setItem(COOLDOWN_STORAGE_KEY, `${Date.now() + seconds * 1000}`)
	}

	useEffect(() => {
		const stored = localStorage.getItem(COOLDOWN_STORAGE_KEY)
		if (!stored || isNaN(+stored)) return

		const remaining = Math.round((+stored - Date.now()) / 1000)
		if (remaining > 0) setResendCooldown(remaining)
	}, [])

	useEffect(() => {
		if (resendCooldown <= 0) return

		const timeoutId = setTimeout(() => {
			setResendCooldown(prev => (prev > 1 ? prev - 1 : 0))
		}, 1000)

		return () => clearTimeout(timeoutId)
	}, [resendCooldown])

	return {
		resendCooldown,
		isCooldown: resendCooldown > 0,
		startCooldown
	}
}
